/** Shared OAuth callback / popup cancel messaging (Meta deny, etc.). */

export type OAuthCallbackFailure = {
    error?: string | null;
    error_description?: string | null;
    error_reason?: string | null;
    cancelled?: boolean;
    message?: string;
};

export function isOAuthAccessDenied(error?: string | null, errorReason?: string | null): boolean {
    const e = (error || '').toLowerCase();
    const r = (errorReason || '').toLowerCase();
    return e === 'access_denied' || r === 'user_denied' || r === 'user_denied_permission';
}

export function oauthCancelMessage(provider?: string | null): string {
    const p = (provider || '').toLowerCase();
    if (p === 'meta' || p === 'facebook' || p === 'instagram') {
        return 'Meta connection was cancelled. You can try again anytime.';
    }
    if (p === 'tiktok') {
        return 'TikTok connection was cancelled. You can try again anytime.';
    }
    if (p === 'youtube' || p === 'google') {
        return 'YouTube connection was cancelled. You can try again anytime.';
    }
    const label = provider ? provider.charAt(0).toUpperCase() + provider.slice(1) : 'Social';
    return `${label} connection was cancelled. You can try again anytime.`;
}

export function parseOAuthCallbackSearch(search: string): {
    code: string | null;
    error: string | null;
    error_description: string | null;
    error_reason: string | null;
    cancelled: boolean;
} {
    const params = new URLSearchParams(search);
    const code = params.get('code') || params.get('auth_code');
    const error = params.get('error');
    const error_description = params.get('error_description');
    const error_reason = params.get('error_reason');
    const cancelled = isOAuthAccessDenied(error, error_reason) || Boolean(error && !code);
    return { code, error, error_description, error_reason, cancelled };
}
